<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<div class="img_container1">
<img alt="images" src="images/f000i-01.jpg"/>
<p class="caption">An M1132 ESC of Alpha Troop, Regimental Engineer Squadron, 2nd Cavalry Regiment brings up a Mine Clearing Line Charge at the Grafenwoehr Training Area in March 2016. (US Army photo by Sgt. William Tanner)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm.vue?d50e3422